import React from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';

import PrevArrow from '@app/imgs/PrevArrow';
import NextArrow from '@app/imgs/NextArrow';

import '@app/scss/components/photoGallery.scss';

interface PhotoGalleryProps {
	slides: Array<{
		alt: string;
		src: string;
	}>;
	show: boolean;
	setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const PhotoGallery: React.FC<PhotoGalleryProps> = ({ slides, show, setShow }) => {
	const [swiper, setSwiper] = React.useState<any>();

	const close = () => {
		setShow(false);
	};

	React.useEffect(() => {
		if (show) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'visible';
		}
	}, [show]);

	if (!show) {
		return null;
	}

	return (
		<div
			className="gallery-container"
			onClick={close}
		>
			<div
				className="container"
				onClick={(e) => {
					e.stopPropagation();
				}}
			>
				<div className="gallery">
					<div
						className="close"
						onClick={() => setShow(false)}
					>
						<svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
							<path
								d="M27.9498 15.0508L15.0498 27.9508M15.0498 15.0508L27.9498 27.9508"
								stroke="#fefefe"
								strokeWidth="4"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</div>
					<div className="prev">
						<PrevArrow onClick={() => swiper?.slidePrev()} />
					</div>
					<Swiper
						onChange={(...rest) => console.log(rest)}
						onBeforeInit={(swiper) => setSwiper(swiper)}
						pagination={{
							type: 'fraction',
						}}
						navigation
						modules={[Pagination, Navigation]}
					>
						{slides.map((slide, i) => <SwiperSlide key={i}>
							<img src={slide.src} alt={slide.alt} />
						</SwiperSlide>)}
					</Swiper>
					<div className="next">
						<NextArrow onClick={() => swiper?.slideNext()} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default PhotoGallery;
